import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.VisitStep ??= {};

AppointmentBooking.Wizard.Views.VisitStep.ReturningPatientField = class ReturningPatientField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    return this.listenTo(this.model, "change:provider", this.render);
  }
};
AppointmentBooking.Wizard.Views.VisitStep.ReturningPatientField.prototype.template =
  "step/visit/fields/returning_patient";
AppointmentBooking.Wizard.Views.VisitStep.ReturningPatientField.prototype.className =
  "appointment-booking-wizard-visit-step-returning-patient-field";
